module.exports = __webpack_public_path__ + "assets/img/callQualityInspection-banner.31adcf9e.png";